export const InputError = ({ errorTitle }) => {
  return (
    <>
      <div className={`flex items-center text-red text-sm mt-2`}>
        <p className="ml-2">{errorTitle}</p>
      </div>
    </>
  );
};
